import { combineReducers } from 'redux'

import app from '../app/app_reducer'
import account from '../ui/account/account_reducer'
import impostazioni from '../ui/impostazioni/impostazioni_reducer'

import testReducer from "../ui/test/testReducer"
import localizzazione from '../ui/localizzazione/i18n_reducer'
import home from '../ui/home/HomeReducer'
import documentiReducer from '../ui/documenti/DocumentiReducer'
import DataSourceReducer from '../ui/dataSource/DataSourceReducer'

const appReducers = combineReducers({
  app,
  account,
  home,
  impostazioni,
  testReducer,
  localizzazione,
  documentiReducer,
  DataSourceReducer
});

export default appReducers;